import { AppStateFailure, IStateSlice } from '@symphony-solo/shared/common-state/src';
import { PriceLevelDto } from '../dtos';

export class PriceLevelsState implements IStateSlice {
  public isLoading: boolean;
  public failures: AppStateFailure;
  public priceLevels: { [taxrateId: number]: PriceLevelDto };

  constructor() {
    this.isLoading = false;
    this.failures = null;
    this.priceLevels = null;
  }
}
